import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { EvidaScreens } from 'src/app/tracking/evida-screens'
import { SimpleAnalytics } from 'src/app/tracking/simple-analytics'
import { Logger } from 'src/app/utils/logger'

@Component({
    selector: 'app-site-busy',
    templateUrl: './site-busy-component.html',
    styleUrls: ['./site-busy-component.scss'],
    standalone: false,
})
export class SiteBusyComponent {
    constructor(
        private router: Router,
        private logger: Logger
    ) {
        this.trackErrorBusy()
    }
    private trackErrorBusy() {
        SimpleAnalytics.trackScreen(EvidaScreens.Error.busy)
    }
}
